import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from 'swiper/modules';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import "swiper/css";
import "swiper/css/pagination";

import choo1 from "../../../assets/assets-home/img/popular/1.webp";
import choo2 from "../../../assets/assets-home/img/popular/2.webp";
import choo3 from "../../../assets/assets-home/img/popular/3.webp";
import choo4 from "../../../assets/assets-home/img/popular/4.webp";
import choo5 from "../../../assets/assets-home/img/popular/5.webp";
import choo6 from "../../../assets/assets-home/img/popular/6.webp";
import choo7 from "../../../assets/assets-home/img/popular/7.webp";
import choo8 from "../../../assets/assets-home/img/popular/8.webp";
import choo9 from "../../../assets/assets-home/img/popular/9.webp";
import choo10 from "../../../assets/assets-home/img/popular/10.webp";
import SpeakToExpertButton from "src/components/home/SpeakToExpertButton";

type Client = { img: string; labelKey: string; link?: string };

const clients: Client[] = [
  { img: choo1, labelKey: "clientsChoose.items.maldives", link: "/maldives" },
  { img: choo2, labelKey: "clientsChoose.items.safari", link: "/safari" },
  { img: choo3, labelKey: "clientsChoose.items.bodrum" },
  { img: choo4, labelKey: "clientsChoose.items.saintTropez" },
  { img: choo5, labelKey: "clientsChoose.items.seychelles" },
  { img: choo6, labelKey: "clientsChoose.items.mauritius" },
  { img: choo7, labelKey: "clientsChoose.items.paris" },
  { img: choo8, labelKey: "clientsChoose.items.uae" },
  { img: choo9, labelKey: "clientsChoose.items.china" },
  { img: choo10, labelKey: "clientsChoose.items.privateAviation" },
];

const ClientsChooseSlider = () => {
  const { t } = useTranslation('home');
  return (
    <div className="clients_choose !pb-8 sm:!pb-10 lg:!pb-[60px]">
      <h2 className="section-heading text-center mb-6 sm:mb-8 lg:mb-10 px-5 sm:px-6 lg:px-10">
        <Trans
          i18nKey="clientsChoose.heading"
          ns="home"
          components={{ br1: <br className="sm:hidden" /> }}
        />
      </h2>

      <div className="min-h-[50vw] sm:min-h-[312px] lg:min-h-[462px]">
        <Swiper
          modules={[Pagination]}
          loop={true}
          slidesPerView={"auto"}
          centeredSlides={true}
          slideToClickedSlide={true}
          spaceBetween={13}
          pagination={{ clickable: true, el: ".clients_choose_pagination" }}
          speed={300}
          touchEventsTarget="container"
          breakpoints={{
            640: { spaceBetween: 26 },
            1100: { spaceBetween: 40 }
          }}
          className="clients_choose_slider"
        >
          {clients.map((client, index) => {
            const label = t(client.labelKey);
            return (
              <SwiperSlide key={index}>
                <div className="clients_choose_item">
                  <div className="clients_choose_item__img">
                    <img src={client.img} alt={label} />
                  </div>
                  <div className="clients_choose_item__label capitalize">
                    <span>{label}</span>
                  </div>
                  {client.link && (
                    <Link
                      to={client.link}
                      className="clients_choose_item__learn-more absolute right-[6.5px] bottom-[6.5px] sm:right-[14px] sm:bottom-[14px] lg:right-5 lg:bottom-5 inline-flex items-center gap-1 sm:gap-2 text-white hover:text-white focus:text-white visited:text-white font-semibold text-[10px] sm:text-[18px] leading-[8px] sm:leading-[18px] no-underline [text-shadow:0_1px_3px_rgba(0,0,0,0.6)] [&_svg]:drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]"
                    >
                      <span>{t('clientsChoose.learnMore')}</span>
                      <svg
                        className="sm:hidden shrink-0"
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.33398 4H6.66732M6.66732 4L4.66732 2M6.66732 4L4.66732 6"
                          stroke="white"
                          strokeWidth="0.75"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <svg
                        className="hidden sm:block shrink-0"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 9H15M15 9L10.5 4.5M15 9L10.5 13.5"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>

      <div className="pagination clients_choose_pagination"></div>

      <div className="flex justify-center mt-8">
        <SpeakToExpertButton />
      </div>
    </div>
  );
};

export default ClientsChooseSlider;
